import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionTitle, Loading } from "@/components/common";
import { Building2, Plug, Route, ShieldCheck } from "lucide-react";

export default function Organization() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/organization").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <Loading label="Loading organization" />;
  const o = d.organization;

  return (
    <div className="max-w-5xl">
      <SectionTitle sub="Read-only organization configuration · architecture prepared for future multi-organization platform">Organization</SectionTitle>

      <div className="sg-card p-5 mb-6" data-testid="org-profile">
        <div className="font-head font-bold mb-3 flex items-center gap-2"><Building2 size={18} /> {o.name}</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <Field label="Legal name" value={o.legal_name} />
          <Field label="Org ID" value={o.org_id} />
          <Field label="Accent" value={o.accent} />
          <Field label="Theme" value={o.theme} />
          <Field label="Status" value={o.active ? "Active" : "Inactive"} />
        </div>
        <div className="text-xs mt-4 p-3 rounded-lg" style={{ background: "rgba(59,130,246,0.08)", color: "var(--txt2)" }} data-testid="org-note">{d.note}</div>
      </div>

      <div className="sg-card p-5 mb-6" data-testid="org-integrations">
        <div className="font-head font-bold mb-3 flex items-center gap-2"><Plug size={18} /> Integration Boundaries</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {d.integrations.map((i) => (
            <div key={i.key} className="sg-card-elev p-3" data-testid={`integration-${i.key}`}>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-sm">{i.name}</span>
                <span className="chip" style={{ background: "rgba(245,158,11,0.12)", color: "#F59E0B", borderColor: "#F59E0B", fontSize: 10 }}>{i.status}</span>
              </div>
              <div className="text-xs mt-1" style={{ color: "var(--txt2)" }}>{i.scope}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="sg-card p-5" data-testid="org-roadmap">
          <div className="font-head font-bold mb-3 flex items-center gap-2"><Route size={18} /> Phase Roadmap</div>
          {Object.entries(d.phase_roadmap).map(([k, v]) => (
            <div key={k} className="flex items-start gap-2 mb-2 text-sm">
              <span className="chip" style={{ background: "var(--bg-elev)", color: "var(--accent)", borderColor: "var(--brd)", textTransform: "uppercase", fontSize: 10 }}>{k.replace(/_/g, " ")}</span>
              <span style={{ color: "var(--txt2)" }}>{v}</span>
            </div>
          ))}
        </div>
        <div className="sg-card p-5" data-testid="org-hierarchy">
          <div className="font-head font-bold mb-3 flex items-center gap-2"><ShieldCheck size={18} /> Architecture</div>
          <div className="text-sm" style={{ color: "var(--txt2)" }}>{d.hierarchy}</div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wider" style={{ color: "var(--txt2)" }}>{label}</div>
      <div className="font-mono mt-0.5">{value || "—"}</div>
    </div>
  );
}
